import React from 'react';
import classNames from 'classnames';
import TextSkeleton from '../../../skeletons/text-skeleton';
import ButtonSkeleton from '../../../skeletons/button-skeleton';
import Heading from '../../../heading';
import Paragraph from '../../../paragraph';
import ActionButton from '../../../action-button';
import InfoWithPopover from '../../../info-with-popover';
import HorizontalStack from '../../../horizontal-stack';
import {
  APPEARANCES as BUTTON_APPEARANCES,
  FORMATS as BUTTON_FORMATS,
} from '../../../action-button/constants';
import { HEADING_APPEARANCES } from '../../../heading/constants';

const DomainSelectorListRow = ({
  captions,
  disabled = false,
  onClick = Function.prototype,
  isLoading = false,
  buttonAppearance = BUTTON_APPEARANCES.default,
  buttonFormat = BUTTON_FORMATS.solid,
  priceAppearance = HEADING_APPEARANCES.default,
}) => {
  const listRowClasses = classNames('ws-ui-domain-selector-list-row', {
    'ws-ui-domain-selector-list-row--loading': isLoading,
    'ws-ui-domain-selector-list-row--disabled': disabled,
  });

  return (
    <div className={listRowClasses}>
      <div className="ws-ui-domain-selector-list-row__container">
        <div className="ws-ui-domain-selector-list-row__title-wrapper">
          {!isLoading && captions.label && (
            <Paragraph size="small" appearance="accent" weight="medium">
              {captions.label}
            </Paragraph>
          )}
          <div className="ws-ui-domain-selector-list-row__title">
            <Heading type="heading-5">
              {isLoading ? <TextSkeleton width="211px" /> : captions.title}
            </Heading>
          </div>
        </div>
        <div className="ws-ui-domain-selector-list-row__price-container">
          {isLoading && (
            <div className="ws-ui-domain-selector-list-row__price">
              <TextSkeleton width="44px" />
            </div>
          )}
          {!isLoading && (captions.price || captions.priceDescription) && (
            <React.Fragment>
              {captions.price && (
                <div className="ws-ui-domain-selector-list-row__price-wrapper">
                  <HorizontalStack gap="spacing-3-xs" verticalAlign="center">
                    {captions.oldPrice && (
                      <div className="ws-ui-domain-selector-list-row__old-price">
                        <Paragraph>
                          <s>{captions.oldPrice}</s>
                        </Paragraph>
                      </div>
                    )}
                    <div className="ws-ui-domain-selector-list-row__price">
                      <Heading
                        appearance={priceAppearance}
                        type={disabled ? 'heading-6' : 'heading-5'}
                        singleLine
                      >
                        {disabled ? captions.price : <b>{captions.price}</b>}
                      </Heading>
                    </div>
                  </HorizontalStack>
                </div>
              )}
              {captions.priceDescription && (
                <div className="ws-ui-domain-selector-list-row__price-description">
                  <Paragraph size="small">{captions.priceDescription}</Paragraph>{' '}
                  {captions.popoverContent && (
                    <InfoWithPopover
                      content={captions.popoverContent}
                      appearance="dark"
                      placement="bottom-center"
                    />
                  )}
                </div>
              )}
            </React.Fragment>
          )}
        </div>
      </div>
      {!disabled && (
        <div className="ws-ui-domain-selector-list-row__button">
          {isLoading ? (
            <ButtonSkeleton />
          ) : (
            <ActionButton
              label={captions.button}
              appearance={buttonAppearance}
              format={buttonFormat}
              onClick={onClick}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default DomainSelectorListRow;
